import styled, {keyframes} from "styled-components";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const TransferDashboardContainer = styled.div`
    padding: 16px;
    width: 100%;
    max-width: 1600px;
    margin: 0 auto;
`;

export const MetabaseIframe = styled.iframe`
    border: none;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    min-height: 800px;
    width: 100%;
`;

export const LoadingIndicator = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 400px;
    font-size: 18px;
    color: #666;

    &::before {
        content: "";
        width: 40px;
        height: 40px;
        margin-bottom: 15px;
        border: 4px solid #f3f3f3;
        border-top: 4px solid #3498db;
        border-radius: 50%;
        animation: ${spin} 1s linear infinite;
    }
`;

export const DashboardTitle = styled.h1`
    margin-bottom: 24px;
`;
